models.service('UserModel', [
    'constants', 'LocalStorage', 'appsflyer', 'Utils', 'config', 'Storage',
    function (Const, LocalStorage, appsflyer, Utils, Config, Storage) {
        /**
         * @name UserModel
         * @class
         */
        function User() {
            var self = this;

            self.login = '';

            self.email = '';
            self.firstName = '';
            self.lastName = '';
            self.country = '';
            self.address = '';
            self.city = '';
            self.postCode = '';

            self.phone = '';
            self.birthday = '';

            self.nationalId = '';
            self.citizenship = '';
            self.birthCountry = '';
            self.timeZone = '';

            /**
             * @type {TradingAccount}
             */
            self.activeTradingAccount = null;
            self.currency = 'USD';
            self.baseCurrency = null;
            self.currencyDigits = 2;
            self.registrationState = 0;

            //self.salesStatus;
            self.complianceStatus = '';
            self.complianceStatusNegative = false;
            self.language = '';

            self.isSuspended = false;
            self.isBlocked = false;

            self.tradingAccounts = [];
            self.loggedIn = false;

            self.leverage = Config.defaultLeverage || 100;
            self.usCitizen = false;
            self.usTaxId = '';
            self.smsVerified = false;
            self.state = '';
            self.liveAccountExists = false;
            self.customerType = '';
            self.otpEnabled = false;
            self.classification = '';

            self.isMarried = false;
            self.tnc = false;
            self.token = null;

            self.tin = '';
            self.taxCountry = '';
            self.companyName = '';

            self.riskAcceptance = false;
            self.riskApprovalDate = false;
            self.depositValidationRequired = false;
            self.birthPlace = '';

            self.funded = false;
            self.customerId = '';

            self.gender = undefined;
            self.regulation = '';
            self.intercomHash = '';
            self.emailVerificationRequired = false;

            //common login
            this.onLogin = function (user) {
                self.customerId = user.hashedCustomerId;
                self.login = user.login;
                self.email = user.login;
                self.firstName = user.firstName;
                self.lastName = user.lastName;
                self.country = user.country;
                self.address = user.address;
                self.city = user.city;
                self.postCode = user.postCode;

                self.phone = user.phone.replace('+', '');
                self.birthday = user.birthday;

                self.nationalId = user.nationalId;
                self.citizenship = user.citizenship;
                self.birthCountry = user.birthCountry;

                self.registrationState = user.registrationState;

                self.salesStatus = user.salesStatus;
                self.complianceStatus = user.complianceStatus;
                self.setComplianceStatus();
                self.language = user.language;

                self.isSuspended = Utils.toBoolean(user.isSuspended);
                self.isBlocked = Utils.toBoolean(user.isBlocked);
                self.usCitizen = user.usCitizen === 1 || false;
                self.usTaxId = user.usTaxId;
                self.smsVerified = Utils.toBoolean(user.smsVerified);
                self.liveAccountExists = Utils.toBoolean(user.mt4AccountsLiveExists);
                self.baseCurrency = user.currency;
                self.state = user.state || '';
                self.customerType = user.customerType || '';
                self.otpEnabled = !!user.otpEnabled;
                self.classification = user.classification;

                self.depositValidationRequired = Utils.toBoolean(user.validationRequired);
                self.birthPlace = user.birthPlace;
                self.intercomHash = user.intercomHash || '';

                if (user.mt4Accounts.length > 0) {
                    self.tradingAccounts = user.mt4Accounts.map(initTradingAccount);
                    self.activeTradingAccount = self.setActiveAccount();

                    //if no account marked active - get first account from list
                    /*if (!self.activeTradingAccount) {
                        self.activeTradingAccount = self.tradingAccounts[0];
                    }*/
                    if (!self.activeTradingAccount) return;

                    self.currency = self.activeTradingAccount.currency;
                    var currency = (Storage.get('currencies') || []).find(function (currency) {
                        return currency.currency === self.currency;
                    });
                    self.currencyDigits = currency.digits;
                }

                self.isMarried = Utils.toBoolean(user.married);
                self.tnc = Utils.toBoolean(user.terms);

                self.tin = user.tin;
                self.taxCountry = user.taxCountry;
                self.companyName = user.companyName;

                self.riskApprovalDate = user.riskApprovalDate;
                this.updateRisk();

                self.funded = Utils.toBoolean(user.funded);
                self.gender = user.gender;
                self.regulation = user.regulation;
                self.emailVerificationRequired = Utils.toBoolean(user.emailVerificationRequired);
            };

            this.updateRisk = function () {
                if (!Const['scoringRules']) {
                    self.riskAcceptance = false
                    return
                }

                var scoringRule = _.find(Const['scoringRules'], {classification: self.classification});
                if (!scoringRule) {
                    self.riskAcceptance = false
                    return
                }

                //
                if (self.classification === 'Rejected') {
                    self.riskAcceptance = false;
                    return
                }

                if (scoringRule.hasOwnProperty('acceptPopup') && scoringRule['acceptPopup'] === true && self.riskApprovalDate.length === 0) {
                    self.riskAcceptance = true
                }
            }

            function initTradingAccount(account) {
                var currency = (Storage.get('currencies') || []).find(function (_currency) {
                    return _currency.currency === account.currency;
                });
                /**
                 * @name TradingAccount
                 * @class
                 */
                return {
                    login: account.login,
                    currency: account.currency,
                    isCryptoCurrency: Utils.toBoolean(parseInt(currency.crypto)),
                    leverage: account.leverage || 100,
                    active: Utils.toBoolean(account.active),
                    balance: account.balance,
                    equity: account.equity,
                    freeMargin: account.freeMargin,
                    marginLevel: account.marginLevel,
                    margin: account.margin || 0,
                    credit: account.credit,
                    source: account.source,
                    live: Utils.toBoolean(account.live),
                    id: [account.login, account.source, account.live].join('-'), //unique trading account identifier (login-0|1)
                    tradingPlatform: account.tradingPlatform || "MT4",
                    cryptoWallet: account.cryptoWallet || {},
                    isEsma: Utils.toBoolean(account.isESMA),
                    currencyDigits: currency.digits,
                    customerType: account.customerType,
                };
            }

            this.addTradingAccount = function (account) {
                var _account = initTradingAccount(account);
                self.tradingAccounts.push(_account);
                if (_account.live) self.liveAccountExists = true;
            };

            this.setActiveAccount = function () {
                return self.tradingAccounts
                    .filter(function (account) {
                        return account.active
                    })
                    .shift();
            };

            this.switchAccount = function (login, live) {
                self.tradingAccounts
                    .forEach(function (account) {
                        account.active = false;
                        if (account.login === login && account.live === live) account.active = true;
                    });

                self.activeTradingAccount = self.setActiveAccount();
                self.currency = self.activeTradingAccount.currency;
                self.currencyDigits = ((Storage.get('currencies') || []).find(function (currency) {
                    return currency.currency === self.currency;
                })).digits;
            };

            this.updateBalance = function (data) {
                //update balance per account
                var account = self.getAccount(data.login, data.live === 1);
                if (account) {
                    account.balance = data.Balance;
                    account.margin = data.Margin;
                    account.equity = data.Equity;
                    account.credit = data.Credit;
                    account.freeMargin = account.equity - account.margin;
                }
            };

            this.isDemoAccounts = function () {
                return self.tradingAccounts
                    .filter(function (account) {
                        return !account.live
                    }).length
            };

            this.isLiveAccounts = function () {
                return this.tradingAccounts.filter(function (account) {
                    return account.live
                }).length
            };

            this.getAccount = function (login, isLive) {
                return this.tradingAccounts
                    .filter(function (account) {
                        return account.login === login && account.live === isLive
                    })
                    .pop();
            };

            this.updatePersonalDetails = function (data) {
                this.firstName = data.firstName;
                this.lastName = data.lastName;
                this.birthday = data.birthday;
                this.country = data.country;
                this.currency = data.currency;
                this.address = data.address;
                this.city = data.city;
                this.postCode = data.postCode;
                this.phone = data.phone.replace('+', '');
                this.citizenship = data.citizenship;
                this.state = data.state || '';
                this.customerType = data.customerType || '';
                this.currencyDigits = ((Storage.get('currencies') || []).find(function (currency) {
                    return currency.currency === data.currency;
                })).digits;
                this.classification = data.classification;
                this.depositValidationRequired = Utils.toBoolean(data.validationRequired);
            };

            this.setComplianceStatus = function () {
                var negativeStatuses = ['no kyc', 'rejected', 'partial kyc', 'awaiting review'];
                var positiveStatuses = ['partial kyc - can trade'];

                if (this.complianceStatus === 'approved') {
                    this.complianceStatusNegative = false;
                    return;
                }

                if (negativeStatuses.indexOf(this.complianceStatus) > -1) {
                    this.complianceStatusNegative = true;
                }
                if (positiveStatuses.indexOf(this.complianceStatus) > -1) {
                    this.complianceStatusNegative = false;
                }
            }

            this.getCustomer = function () {
                return {
                    login: this.login,
                    email: this.email,
                    firstName: this.firstName,
                    lastName: this.lastName,
                    country: this.country,
                    address: this.address,
                    city: this.city,
                    postCode: this.postCode,
                    phone: this.phone,
                    birthday: this.birthday,
                    citizenship: this.citizenship,
                    currency: this.currency,
                    registrationState: this.registrationState,
                    salesStatus: this.salesStatus,
                    complianceStatus: this.complianceStatus,
                    isSuspended: this.isSuspended,
                    isBlocked: this.isBlocked,
                    loggedIn: this.loggedIn,
                    smsVerified: this.smsVerified,
                    liveAccountExists: this.liveAccountExists,
                    tradingAccounts: this.tradingAccounts,
                    funded: this.funded,
                    customerId: this.customerId
                }
            }

            // FSA regulations
            this.isRegulated = function() {
                var regulations = Const['regulations'];
                if (!regulations) {
                    return false
                }
                return regulations.hasOwnProperty(self.regulation)
                    && regulations[self.regulation] === true && !self.classification.length;
            }
        }

        return User;
    }]);
